// Event focus can be used to focus on a particular element
// Parameters:
// * `dom_id` or `dom_name`
// * `next_tick` (optional, default is `false`).
// * `select` (if input should also be selected, optional, default is `false`).
export const Focus = {
  init() {
    window.addEventListener("phx:focus", (e) => {
      if (e.detail.next_tick) setTimeout(() => Focus.focus(e), 0)
      else Focus.focus(e)
    })
  },

  focus(e) {
    const element = e.detail.dom_id
      ? document.getElementById(e.detail.dom_id)
      : document.querySelector(`[name="${e.detail.dom_name}"]`)

    if (element) {
      element.focus()

      if (e.detail.select) element.select()
    }
  },
}

Focus.init()
